import { render, staticRenderFns } from "./AsinScraperListGridFooter.vue?vue&type=template&id=18ac3ef5"
import script from "./AsinScraperListGridFooter.vue?vue&type=script&lang=js"
export * from "./AsinScraperListGridFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports